import type { CalendarsTranslationMessages } from './calendarsTranslationMessages';

const personalCalendarsLanguageItalian: CalendarsTranslationMessages['me/calendars'] = {
  name: 'Calendari',
  fields: {
    id: 'ID',
    description: 'Descrizione',
    title: 'Titolo',
    mode: 'Modalità',
  },
  operations: {
    create: 'Crea calendario',
    delete: 'Elimina calendario',
    edit: 'Modifica calendario',
  },
};

const personalCalendarEventsLanguageItalian: CalendarsTranslationMessages['me/calendar_events'] = {
  name: 'Eventi personali',
  fields: {
    all_day: 'Tutto il giorno',
    calendar: 'Calendario',
    description: 'Descrizione',
    dtend: 'Fine',
    dtstart: 'Inizio',
    id: 'ID',
    metadata: 'meta',
    title: 'Titolo',
    tzid: 'Fuso Orario',
    rrule: {
      count: 'Numero occorrenze',
      freq: 'Frequenza',
      until: 'Date fine occorrenze',
      bymonth: 'Occorrenze nei mesi di',
      bymonthday: 'Occorrenze nei giorni del mese',
      byweekday: 'Occorrenze nei giorni della settimana',
      interval: 'Intervallo',
    },
    enableRrule: 'Abilita ricorrenza',
    recurrenceType: 'Tipo di ricorrenza',
  },
  operations: {
    create: 'Crea evento',
    delete: 'Elimina evento',
    edit: 'Modifica evento',
    sections: {
      details: 'Dettagli evento',
      advancedSettings: 'Avanzate',
    },
  },
  frequencies: {
    daily: 'Ogni giorno',
    weekly: 'Ogni settimana',
    monthly: 'Ogni mese',
    yearly: 'Ogni anno',
  },
  weekdays: {
    mo: 'Lunedì',
    tu: 'Martedì',
    we: 'Mercoledì',
    th: 'Giovedì',
    fr: 'Venerdì',
    sa: 'Sabato',
    su: 'Domenica',
  },
  months: {
    1: 'Gennaio',
    2: 'Febbraio',
    3: 'Marzo',
    4: 'Aprile',
    5: 'Maggio',
    6: 'Giugno',
    7: 'Luglio',
    8: 'Agosto',
    9: 'Settembre',
    10: 'Ottobre',
    11: 'Novembre',
    12: 'Dicembre',
  },
  recurrenceTypes: {
    counted: 'Numero di eventi',
    until: 'Fino ad una data',
  },
};

const domainCalendarsLanguageItalian: CalendarsTranslationMessages['calendars'] = {
  ...personalCalendarsLanguageItalian,
  fields: {
    ...personalCalendarsLanguageItalian.fields,
    labels: { id: 'Etichette', name: 'Etichette' },
    owner: 'Proprietario',
  },
  operations: {
    ...personalCalendarsLanguageItalian.operations,
    sections: {
      details: 'Dettagli calendario',
    },
  },
};

const domainCalendarEventsLanguageItalian: CalendarsTranslationMessages['calendar_events'] = {
  ...personalCalendarEventsLanguageItalian,
  name: 'Eventi',
};

export const calendarsLanguageItalian: CalendarsTranslationMessages = {
  'me/calendars': personalCalendarsLanguageItalian,
  'me/calendar_events': personalCalendarEventsLanguageItalian,
  calendars: domainCalendarsLanguageItalian,
  calendar_events: domainCalendarEventsLanguageItalian,
};
